<template>
  <div class="ott-add-ons-area ptb-100">
    <div class="container">
      <div
        class="section-title mw-526 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <h2 class="text-white">خصّص تجربتك مع ميزاتنا الإضافية</h2>
      </div>

      <div class="row justify-content-center align-items-center">
        <div
          class="col-lg-6 col-md-12"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="ott-add-ons-image">
            <img src="@/assets/images/ott-platform/add-ons.jpg" alt="image" />
          </div>
        </div>

        <div
          class="col-lg-6 col-md-12"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="300"
        >
          <div class="ott-add-ons-content">
            <div class="accordion" id="accordionOns">
              <div
                v-for="(addon, index) in addons"
                :key="index"
                class="accordion-item"
                :class="{ active: activeIndex === index }"
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    :aria-expanded="activeIndex === index ? 'true' : 'false'"
                    @click="toggleAccordion(index)"
                  >
                    {{ addon.title }}
                  </button>
                </h2>
                <div
                  class="accordion-collapse collapse show"
                  v-show="activeIndex === index"
                >
                  <div class="accordion-body">
                    <p>{{ addon.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "CustomizeYourExperience",
  setup() {
    const activeIndex = ref<number>(0); // To store which accordion is active

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    const addons = ref([
      {
        title: "إضافات تناسب الجميع",
        description:
          "اكتشف الخيارات الإضافية للحصول على ميزات متطورة، قنوات تلفزيونية متميزة، محتوى ترفيهي أوسع، وبث مباشر لأقوى البطولات الرياضية والقنوات العالمية.",
      },
      {
        title: "دعم جودة فائقة 4K",
        description: "استمتع بمشاهدة سيرفراتنا بأعلى دقة ممكنة 4K و Ultra HD مع ميزات تشغيل متطورة وبدون تجميد.",
      },
      {
        title: "باقات تلفزيونية مميزة",
        description: "وصول كامل إلى القنوات التلفزيونية المشفرة والمميزة لتجربة مشاهدة استثنائية.",
      },
      {
        title: "محتوى ترفيهي متكامل",
        description: "استمتع بتشكيلة واسعة وضخمة من المحتوى الترفيهي الذي يضم أحدث المنصات العالمية.",
      },
      {
        title: "قنوات عالمية ولغات متعددة",
        description: "إمكانية الوصول إلى باقات القنوات الأجنبية والعالمية المفضلة لديك بمختلف اللغات التلفزيونية.",
      },
      {
        title: "تغطية رياضية مباشرة",
        description: "تابع الأحداث والمباريات الرياضية الحصرية والمباشرة في أي وقت ومن أي مكان.",
      },
    ]);

    return {
      activeIndex,
      toggleAccordion,
      addons,
    };
  },
});
</script>